export default "__VITE_ASSET__BV2CYDNh__"